<template>
  <div class="page">
    <div class="heading">АКТ {{ billNumber }}</div>
    <div class="header">
      <p>м. Київ</p>
      <p>{{ formatDate(createdDate, 'DD MMMM YYYY', { monthNames: monthCases }) }} р.</p>
    </div>
    <div class="text">
      <p> Оператор: {{ invoiceRequisites.name }}, з однієї сторони, та </p>
      <p v-if="isOtherGroup">Клієнт: {{ customer }} з іншої сторони, а разом і надалі за текстом цього
        Акту іменуються як «Сторони», а кожний окремо – як «Сторона», уклали та підписали цей акт (надалі — Акт)
        відповідно до отриманого від Клієнта замовлення та виставленого рахунку-фактури
        № {{ billNumber }}, про наступне: </p>

      <p v-else> Клієнт: {{ customer }} з іншої сторони, а разом надалі за текстом цього
        Акту іменуються як «Сторони», а кожний окремо – як «Сторона», уклали та підписали цей акт надання доступу
        (надалі - Акт)
        відповідно до договору/оферти із сервіс кодом
        № {{ serviceCode }} (надалі - "Договір"), про наступне: </p>
      <p v-if="isOtherGroup">
        1. Згідно із отриманим від Клієнта замовленням та виставленим рахунком-фактурою № {{ billNumber }} Оператор
        надав, а Клієнт прийняв розширення функціоналу комп'ютерної програми (програмної продукції) у вигляді
        онлайн-сервісу (платформи) на наступну суму:
      </p>
      <p v-else>1. Оператор надав Клієнтові доступ, а Клієнт отримав за період
        з {{ formatDate(validFrom, 'DD.MM.YYYY') }} по {{ formatDate(validUntil, 'DD.MM.YYYY') }} доступ до програмної
        продукції від Оператора згідно з Договором
        на наступну суму:
      </p>
      <table class="services">
        <thead>
        <tr>
          <th>№</th>
          <th>Найменування</th>
          <th>Од. вим.</th>
          <th>Кількість</th>
          <th v-if="new Date(this.bill.created_at) > new Date('2020-02-01 00:00:00') &&
              this.invoiceRequisites.additional_info === 'є платником податку на прибуток на  загальних підставах'">Ціна
            без ПДВ*
          </th>
          <th v-else>Ціна без ПДВ*</th>
          <th v-if="new Date(this.bill.created_at) > new Date('2020-02-01 00:00:00') &&
              this.invoiceRequisites.additional_info === 'є платником податку на прибуток на  загальних підставах'">Сума
            без ПДВ*
          </th>
          <th v-else>Сума без ПДВ*</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>1</td>
          <td v-if="new Date(this.bill.created_at) > new Date('2020-02-01 00:00:00')" style="text-align:left;">
            {{ actName }}
          </td>
          <td v-else style="text-align:left;">
            {{ destination }}
          </td>
          <td style="text-align:left;">{{ isOtherGroup ? 'грн' : unit }}</td>
          <td style="text-align:left;">1</td>
          <td style="text-align:left;">{{ amount }}</td>
          <td style="text-align:left;">{{ amount }}</td>
          <!--          <td>{{ formatDate(validFrom, 'DD.MM.YYYY') }} - <br>-->
          <!--              {{ formatDate(validUntil, 'DD.MM.YYYY') }}</td>-->
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td colspan="5" style="text-align: end">Всього до сплати:</td>
          <td style="text-align: start">{{ amount }}</td>
        </tr>
        </tfoot>
      </table>
      <p v-if="this.bill.service.renewable">
        <span v-if="isOtherGroup">
          2.  Сторони погоджуються, що вище наведені послуги надані належним чином та у повному обсязі.
          Клієнт претензій по якості наданого розширення функціоналу комп'ютерної програми не має.
        </span>
        <span v-else>
          2. Сторони погоджуються, що доступ надано згідно з тарифом  {{ serviceName }} з {{
            formatDate(validFrom, 'DD.MM.YYYY')
          }} по {{ formatDate(validUntil, 'DD.MM.YYYY') }} належним чином та у повному обсязі.
        </span>
      </p>
      <p v-else>
        2. Сторони погоджуються, що вище наведені послуги надані належним чином та у повному обсязі.
        <span v-if="isOtherGroup">
          Клієнт претензій по якості наданого розширення функціоналу комп'ютерної програми не має.
        </span>
      </p>
      <p v-if="!isOtherGroup">3. Цей Акт є підставою для проведення розрахунків між Клієнтом та Оператором відповідно до
        Договору (оферти).</p>
      <p v-if="isOtherGroup">3. Загальна сума Винагороди Оператора, за цим Актом, складає {{ amount }} грн
        ({{ amountInWords }}), без ПДВ*.
      </p>
      <p v-else>4. Загальна сума Винагороди Оператора, яка підлягає сплаті Клієнтом на підставі цього Акту, складає
        {{ amount }} грн
        ({{ amountInWords }}), без ПДВ*.
      </p>
      <p v-if="new Date(this.bill.created_at) > new Date('2020-02-01 00:00:00')">
        {{ invoiceRequisites.custom_data }}</p>
      <p v-if="isOtherGroup">4. Цей Акт складено в двох оригінальних примірниках українською мовою (а в випадку
        підписання в електронному вигляді - одному
        примірнику), по одному примірнику для кожної із Сторін. </p>
      <p v-else>Цей Акт складено в двох оригінальних примірниках українською мовою (а в випадку підписання в
        електронному вигляді - одному
        примірнику), по одному примірнику для кожної із Сторін. </p>
    </div>
    <div class="heading">РЕКВІЗИТИ І ПІДПИСИ СТОРІН:</div>
    <div class="requisites">
      <div class="requisites__col">
        <p><b><u>Оператор:</u></b></p>
        <p><b>{{ invoiceRequisites.name }}</b></p>
        <p>{{ invoiceRequisites.address }}</p>
        <p>IBAN {{ invoiceRequisites.checking_account }} <br>
          {{ invoiceRequisites.bank_name }} <br>
        </p>
        <p v-if="isFop"> РНОКПП {{ invoiceRequisites.tin }}</p>
        <p v-else> ЄДРПОУ {{ invoiceRequisites.tin }}</p>
        <p>{{ invoiceRequisites.additional_info }}</p>
      </div>
      <div class="requisites__col">
        <p><b><u>Клієнт:</u></b></p>
        <p><b> {{ getCompanyName }}</b></p>
        <p v-if="getLegalAddress">Юридична адреса: {{ getLegalAddress }}</p>
        <p v-if="getActualAddress"> Адреса фактична: {{ getActualAddress }}</p>
        <p v-if="getInn && getCompanyType === 0 || getCompanyType === 1 || getCompanyType === 4">РНОКПП: {{ getInn }}</p>
        <p v-if="getEdrpou && getCompanyType === 2 || getCompanyType === 3">ЄДРПОУ: {{ getEdrpou }}</p>
        <p v-if="getInn && getCompanyType === 2">IПН: {{ getInn }} </p>
        <p v-if="getIban">IBAN: {{ getIban }}</p>
      </div>
    </div>
    <div class="signatures">
      <div class="signatures__cols">
        <div class="signature">
          <div class="signature__placeholder">
            <img alt="" class="signature__img">
          </div>
          <div class="signature__caption">
            (підпис)
          </div>
          <div class="signature__initials">
            {{ invoiceRequisites.name_in_signature }}
          </div>
        </div>
        <div class="signature">
          <div class="signature__placeholder">

          </div>
          <div class="signature__caption">
            (підпис)
          </div>
          <div class="signature__initials">
            {{ getUserPosition }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import writtenNumber from 'written-number'
import { mapGetters } from 'vuex'
import { date } from 'quasar'
import api from 'mixins/api'
import makeCorrectAmount from 'mixins/makeCorrectAmount'

export default {
  name: 'ActView',

  mixins: [
    api,
    makeCorrectAmount,
  ],

  props: {
    bill: Object,
    act: Object,
    document: Object,
  },

  data () {
    return {
      monthCases: [
        'січня',
        'лютого',
        'березня',
        'квітня',
        'травня',
        'червня',
        'липня',
        'серпня',
        'вересня',
        'жовтня',
        'листопада',
        'грудня',
      ],
      invoiceRequisites: {
        name: '',
        address: '',
        checking_account: '',
        bank_name: '',
        mfi: '',
        tin: '',
        stamp_img_url: '',
        name_in_signature: '',
        custom_data: '',
      },
      ndsData: {
        ndsPayer: '',
      },
    }
  },

  computed: {
    ...mapGetters({
      serviceProvider: 'serviceProviders/getItemById',
    }),

    validFrom () {
      return typeof this.document !== 'undefined' ? this.document.startDate : this.bill.service.valid_from
    },

    validUntil () {
      let date = typeof this.document !== 'undefined' ? this.document.startDate : this.bill.service.valid_from
      let validFromDate = new Date(date)

      return typeof this.document !== 'undefined' ? this.document.endDate : this.bill.service.valid_until ||
          validFromDate.setDate(validFromDate.getDate() + 14)
    },

    serviceCode () {
      return this.bill.project.service_code
    },

    billNumber () {
      return this.bill.number
    },

    serviceProviderId () {
      return this.bill.service_provider_id
    },

    destination () {
      return this.bill.destination
    },

    actName () {
      return this.isOtherGroup
             ? 'Розширення функціоналу комп\'ютерної програми (програмної продукції) у вигляді онлайн-сервісу (платформи).'
             : this.bill.service.service.actName
    },

    unit () {
      return this.bill.service.service.unit
    },

    ndsPayer () {
      return this.ndsData.ndsPayer
    },

    getInn () {
      return this.act.inn
    },

    getActualAddress () {
      return this.act.actual_address
    },

    getLegalAddress () {
      return this.act.legal_address
    },

    getIban () {
      return this.act.iban
    },

    getEdrpou () {
      return this.act.edrpou
    },

    getCompanyName () {
      return this.act.company_name
    },

    getCompanyType () {
      return this.act.company_type
    },

    getUserPosition () {
      switch (this.getCompanyType) {
        case 0:
          return this.act.full_name
                 ? this.act.full_name
                 : `${ this.bill.project.owner.first_name } ${ this.bill.project.owner.last_name }`
        case 1:
        case 4:
          return this.act.company_name
        default:
          return `${ this.act.user_position } ${ this.act.full_name }`
      }
    },

    getFullName () {
      return this.act.full_name
    },

    getContractDate () {
      return this.act.contract_date
    },

    getPersonalInitials () {
      return this.act.person_initials
    },

    amount () {
      let amount = typeof this.document !== 'undefined' && this.document.act_count > 1 && !this.document.is_other_group
                   ? this.bill.amount / this.document.act_count
                   : this.bill.amount

      amount = amount / 100

      return this.resolveAmount(amount)
    },

    serviceName () {
      return typeof this.document !== 'undefined' && this.document.act_count > 1
             ? this.bill.service.service.name.replace('рік', 'місяць')
             : this.bill.service.service.name
    },

    amountInWords () {
      const amountAsString = this.amount.toString(),
          beforeDot = amountAsString.substring(0, amountAsString.indexOf('.')),
          afterDot = amountAsString.substring(amountAsString.indexOf('.') + 1)

      const uah = writtenNumber(Number(beforeDot), {
        lang: 'uk',
      })

      const coinsAmount = afterDot.length === 1 ? `${ afterDot }0` : afterDot

      return `${ uah } гривень ${ coinsAmount } копiйок`
    },

    customer () {
      return this.act.company_name
    },

    clientRequisites () {
      return this.act.requisites.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },

    serviceProviderInitials () {
      return this.act.initials
    },

    customerInitials () {
      return this.act.initials
    },

    createdDate () {
      return this.act.date || this.validUntil
    },

    isFop () {
      return this.invoiceRequisites.name.includes('Фізична')
    },

    isOtherGroup () {
      return this.bill.service.service.groupId === 'other'
    },
  },

  mounted () {
    const serviceProvider = this.serviceProvider(this.serviceProviderId)

    if (serviceProvider) {
      this.invoiceRequisites = this.getInvoiceRequisites(serviceProvider)
    }
    else {
      this.fetchServiceProvider()
    }
  },

  methods: {
    fetchServiceProvider () {
      this.api.get(`service-providers/${ this.serviceProviderId }`).then(response => {
        this.invoiceRequisites = this.getInvoiceRequisites(response.data)
      })
    },
    formatDate (...args) {
      return date.formatDate(...args)
    },
    getInvoiceRequisites (serviceProvider) {
      const invoiceMethod = serviceProvider.payment_details.find(row => row.payment_method === 'invoice')

      if (!invoiceMethod) {
        return
      }

      return Object.assign({
        name: serviceProvider.name,
      }, invoiceMethod.requisites)
    },
  },
}
</script>
<style lang="scss" scoped>
.page {
  max-width: 800px;
  margin: 0 auto;
  font: 13px/1.4 "Times New Roman", serif;

  p {
    margin: 0 0 5px;
  }
}

.heading {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  font-weight: bold;
  font-size: 14px;
}

.services {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;

  th, td {
    padding: 5px;
    border: 1px solid #000;
    text-align: center;
  }
}

.requisites {
  display: flex;
  margin-top: 10px;

  &__col {
    flex: 1 0 0;
  }
}

.signatures {
  margin-top: 30px;

  &__heading {
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  &__cols {
    display: flex;
  }
}

.signature {
  flex: 1 0 0;

  &__head {
    font-size: 16px;
    font-weight: bold;
  }

  &__placeholder {
    position: relative;
    width: 200px;
    height: 80px;
    border-bottom: 2px solid #000;
  }

  &__img {
    position: absolute;
    top: 0;
    width: 210px;
    z-index: -1;
  }

  &__caption {
    width: 200px;
    text-align: center;
  }

  &__initials {
    margin-top: 20px;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/ActView.vue